// V2 Auth specific error codes
export const AUTH_ERROR_CODES = {
  INTERNAL_SERVER_ERROR: '/common/internal-server-error',
  USER_NOT_FOUND: '/auth/user-not-found',
  INVALID_CREDENTIALS: '/auth/invalid-credentials',
  USER_NOT_CONFIRMED: '/auth/user-not-confirmed',
  USER_INACTIVE: '/auth/user-inactive',
  INVALID_VERIFICATION_TOKEN: '/auth/invalid-verification-token',
  REGISTRATION_FAILED: '/auth/registration-failed',
  LOGIN_FAILED: '/auth/login-failed',
  VERIFICATION_FAILED: '/auth/verification-failed',
  USER_ALREADY_EXISTS: '/auth/user-already-exists',
} as const;

export interface ApiOperationError {
  type: string;
  message: string;
  details?: Record<string, unknown>;
}
